// iter691 — Normalize a stored upload path (logo, menu image, category
// cover, etc.) into a fully-qualified URL that the browser will route
// to the FastAPI backend via the Kubernetes ingress.
//
// Why: Older tenants have `logo_url` stored as "/uploads/logos/xxx.png"
// (no /api prefix). The ingress sends anything NOT prefixed with /api
// to the React frontend, which 404s. That's the "broken thermal logo"
// the operator sees in Branding Settings.
//
// New uploads since iter691 are saved as "/api/uploads/logos/..." so
// they're already correct. This helper makes BOTH old and new work.
//
// Usage:
//   import { resolveUploadUrl } from '@/lib/uploadUrl';
//   <img src={resolveUploadUrl(branding.thermal_logo_url)} />

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export function resolveUploadUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  // Already an absolute URL (http/https/data:) — return as-is.
  if (/^(https?:|data:|blob:)/i.test(pathOrUrl)) return pathOrUrl;
  // Already correctly prefixed.
  if (pathOrUrl.startsWith('/api/')) return `${BASE}${pathOrUrl}`;
  // Legacy: stored as "/uploads/..." — backfill the /api prefix.
  if (pathOrUrl.startsWith('/uploads/')) return `${BASE}/api${pathOrUrl}`;
  // Anything else (a bare filename, or some weird path) — fall back
  // to the literal API_BASE + path. Better to surface a real 404 than
  // silently rewrite something we don't understand.
  return `${BASE}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}

export default resolveUploadUrl;
